(() => {
  if (customElements.get('isabelle-product-panels')) return;
  class IsabelleProductPanels extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const { signal } = this._controller;
      const track = this.querySelector('.it-panels__track');
      const previous = this.querySelector('[data-review-prev]');
      const next = this.querySelector('[data-review-next]');
      const status = this.querySelector('.it-panels__status');
      const cards = [...track.children];
      const step = () => cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
      const update = () => {
        if (!track.clientWidth) return;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        const start = Math.min(cards.length, Math.round(track.scrollLeft / step()) + 1);
        const count = Math.max(1, Math.round(track.clientWidth / step()));
        status.textContent = `Reviews ${start}–${Math.min(cards.length, start + count - 1)} of ${cards.length}`;
      };
      const move = (direction) => track.scrollBy({ left: direction * step(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      previous.addEventListener('click', () => move(-1), { signal });
      next.addEventListener('click', () => move(1), { signal });
      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      }, { signal });
      let scrollTimer;
      track.addEventListener('scroll', () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(update, 120);
      }, { passive: true, signal });
      this.querySelector('.it-panels__reviews').addEventListener('toggle', update, { signal });
      this._observer = new ResizeObserver(update);
      this._observer.observe(track);
      this.dataset.ready = 'true';
      previous.hidden = false;
      next.hidden = false;
      update();
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._observer?.disconnect();
      this._controller = null;
    }
  }
  customElements.define('isabelle-product-panels', IsabelleProductPanels);
})();
